import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Profile from "./Profile";
import AddBook from './AddBook';
import { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import NewsPaper from "./NewsPaper";
import StudentData from "./StudentData";
import FacultyData from "./FacultyData";
import LibraryRAGAssistant from "../Student/LibraryRAGAssistant";
import NoticeTicker from "../../components/NoticeTicker";

const Home = () => {
  const [selectedMenu, setSelectedMenu] = useState("My Profile");
  const router = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (router.state === null && !activeToken) {
      navigate("/");
    }
    setLoad(true);

    const handleOpenProfile = () => setSelectedMenu("My Profile");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
      {load && (
        <>
          <Navbar />
          <div className="max-w-7xl mx-auto p-4 md:p-6 lg:p-8 space-y-6">
            <div className="flex flex-wrap items-center justify-center gap-2 p-1.5 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs">
              {[
                { id: "My Profile", label: "My Profile" },
                { id: "AI RAG Assistant", label: "🤖 AI RAG Assistant" },
                { id: "AddBook", label: "Add Book" },
                { id: "NewsPaper", label: "Newspapers" },
                { id: "StudentData", label: "Issue / Return" },
                { id: "FacultyData", label: "Faculty Directory" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  className={`text-center rounded-xl px-4 py-2 text-xs font-bold transition-all cursor-pointer ${
                    selectedMenu === tab.id
                      ? "bg-indigo-600 text-white shadow-xs"
                      : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800/60"
                  }`}
                  onClick={() => setSelectedMenu(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="w-full">
              {selectedMenu === "AddBook" && <AddBook />}
              {selectedMenu === "My Profile" && <Profile />}
              {selectedMenu === "AI RAG Assistant" && <LibraryRAGAssistant />}
              {selectedMenu === "NewsPaper" && <NewsPaper />}
              {selectedMenu === "StudentData" && <StudentData />}
              {selectedMenu === "FacultyData" && <FacultyData />}
            </div>
          </div>
        </>
      )}
      <Toaster position="bottom-center" />
    </div>
  );
}

export default Home